










import { Component, Vue, Prop } from "vue-property-decorator";
import _ from "lodash";

import { UserService } from "@/core/services";
import { UserCollectionModel, AutoCompleteItem } from "@/core/models";
import { UserSelectorCpt } from ".";

@Component({
  components: {
    UserSelectorCpt,
  },
})
export default class UserSelectorDialogCpt extends Vue {
  @Prop() onSelected?: (user: AutoCompleteItem) => void;
  @Prop() findMethod?: (search: string) => Promise<UserCollectionModel[]>;
  @Prop() showDialog = false;

  get isOpen() {
    return this.showDialog;
  }

  onUserSelected(user: AutoCompleteItem) {
    if (this.onSelected) {
      this.onSelected(user);
      this.close();
    }
  }

  close() {
    this.$emit("onClose");
  }
}
